// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperImages-cls1_dl-","cls2":"PaperImages-cls2_k9k PaperImages-cls1_dl-"};